import React, { memo, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import Text from 'components/core/Text';
import { fetchUser } from 'actions/user';
import ReminderSelect from './ReminderSelect';
import TimezoneSelect from './TimezoneSelect';
import { ReminderSelectContainer, TimezoneSelectContainer } from './styles';

const ReminderSettings = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchUser());
  }, [dispatch]);

  return (
    <>
      <Text variant="sectionHeader" transform="uppercase">
        Update Your Reminders
      </Text>
      <ReminderSelectContainer>
        <ReminderSelect />
      </ReminderSelectContainer>
      <ReminderSelectContainer>
        <ReminderSelect isWeekly />
      </ReminderSelectContainer>
      <TimezoneSelectContainer>
        <TimezoneSelect />
      </TimezoneSelectContainer>
    </>
  );
};

export default memo(ReminderSettings);
